<template>
  <div>
    <validation-observer :ref="`${code}-validator`">
      <section-title
        has-line
        content="IV. Observaciones y Hallazgos"
        container-class="mt-4 "
      />
      <div class="row py-3 m-0 d-flex align-items-end" v-if="!isReadOnly">
        <div class="col-md-4 col-12 col-spacing">
          <custom-drop-down
            v-model="skill"
            fieldkey="id"
            label="Destreza(s) a Desarrollar:"
            fieldname="name"
            placeholder="Seleccione"
            :clearable="false"
            :options="getAvailableSkills"
            @input="onSkillChanged"
          />
        </div>
        <div class="col col-spacing mt-2 mt-md-0">
          <ActionButton
            :variant="isMobile ? 'success btn-block' : 'success'"
            :i="`fas fa-file-plus pr-1`"
            @click="addSkill"
            :disabled="skill === null"
          >
            Añadir Destreza
          </ActionButton>
        </div>
      </div>
      <div class="row py-3 m-0 d-flex align-items-end">
        <div v-for="item in selectedSkills" :key="item.id" class="col-12">
          <skill-row
            v-if="isQuestionnaire(item)"
            :skill="item"
            :is-read-only="isReadOnly"
            @delete="onDeleteSkill"
            :at-service-id="referralId"
            v-model="model.skillModel"
          />
          <work-skills
            :value="model.workSkills"
            :skill="item"
            :is-read-only="isReadOnly"
            @delete="onDeleteSkill"
            :at-service-id="referralId"
            v-if="isWorkSkills(item)"
          />
          <daily-living-skills
            :value="model.dailyLivingSkills"
            :skill="item"
            :is-read-only="isReadOnly"
            @delete="onDeleteSkill"
            :at-service-id="referralId"
            v-if="isDailyLivingSkills(item)"
          />
          <interests
            :value="model.interests"
            :skill="item"
            :is-read-only="isReadOnly"
            @delete="onDeleteSkill"
            :at-service-id="referralId"
            v-if="isInterests(item)"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import SkillRow from './components/SkillRow.vue';
import referralAndEquipmentsService from '@/services/api/referralsandequipments.api';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import referralsAndEquipmentSkills from '@/utils/constants/referralsAndEquipmentSkills';
import WorkSkills from './components/WorkSkills.vue';
import DailyLivingSkills from './components/DailyLivingSkills.vue';
import Interests from './components/Interests.vue';
import referralService from '@/services/api/referralsandequipments.api';
import mixAlert from '@/mixins/alert.mixin';
import TABS from '@/utils/constants/evaluationTabs';

export default {
  name: 'Tab-IV',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    SkillRow,
    WorkSkills,
    DailyLivingSkills,
    Interests,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    code: {
      type: String,
      default: () => '',
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
  },
  watch: {
    'value.skills': {
      immediate: true,
      handler(value, oldValue) {
        if (value) {
          this.addCurrentSkill();
        }
      },
    },
    'value.questions': {
      immediate: true,
      handler(value) {
        if (value.length) {
          this.model.skillModel.questions = value;
        }
      },
    },
  },
  data: () => ({
    skill: null,
    skillOptions: [],
    selectedSkills: [],
    value: {
      workSkills: {
        relationWithTesting: null,
        attention: null,
        followInstructions: null,
        toleranceOfTask: null,
        levelOfActivity: null,
        generalAttitude: null,
        workAdditionalRemarks: null,
      },
      dailyLivingSkills: {
        dailyAdditionalObservation: null,
      },
      interests: {
        interests: null,
      },
      skillModel: {
        questions: [],
        additionalRemarks: {
          comuniAdditionalObservation: null,
          importObservations: null,
          resultOfEvaluationAudiological: null,
          ophthalmologicEvaluation: null,
          cognitiveAdditionalObservation: null,
          wordsPerMinutes: null,
          lectureAdditionalObservation: null,
          motoAdditionalObservation: null,
          mathAdditionalObservation: null,
          ownCareAdditionalObservation: null,
          writeAdditionalObservation: null,
        },
      },
      answers: [],
      questions: [],
      skills: [],
    },
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    getAvailableSkills() {
      const selected = this.selectedSkills.map((x) => {
        return x.id;
      });
      return this.skillOptions.filter((x) => !selected.includes(x.id));
    },
    isQuestionnaire() {
      const customList = [
        referralsAndEquipmentSkills.WorkSkills,
        referralsAndEquipmentSkills.DailyLivingSkills,
        referralsAndEquipmentSkills.Interests,
      ];
      return (item) => !customList.includes(item.id);
    },
    isWorkSkills() {
      return (item) => item.id == referralsAndEquipmentSkills.WorkSkills;
    },
    isDailyLivingSkills() {
      return (item) => item.id == referralsAndEquipmentSkills.DailyLivingSkills;
    },
    isInterests() {
      return (item) => item.id == referralsAndEquipmentSkills.Interests;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData() {
      await this.getObservationsFindings();
      this.$emit('loaded', TABS.IV);
    },
    async validate() {
      const valid = await this.$refs[`${this.code}-validator`].validate();

      const hasData = this.selectedSkills.length > 0;
      return {
        valid: valid && hasData,
        message: valid && hasData ? '' : 'Observaciones y Hallazgos',
      };
    },
    async getObservationsFindings() {
      const { data } = await referralService.getObservationsFindings(
        this.referralId
      );
      const { skills } = data;
      this.value = {
        answers: [],
        ...this.value,
        ...data,
        skills,
        skillModel: {
          ...this.value.skillModel,
          additionalRemarks: {
            comuniAdditionalObservation:
              data.communication.comuniAdditionalObservation,
            importObservations: data.sensory.importObservations,
            resultOfEvaluationAudiological:
              data.sensory.resultOfEvaluationAudiological,
            ophthalmologicEvaluation: data.sensory.ophthalmologicEvaluation,
            cognitiveAdditionalObservation:
              data.cognitive.cognitiveAdditionalObservation,
            wordsPerMinutes: data.reading.wordsPerMinutes,
            lectureAdditionalObservation:
              data.reading.lectureAdditionalObservation,
            motoAdditionalObservation: data.moto.motoAdditionalObservation,
            mathAdditionalObservation: data.math.mathAdditionalObservation,
            ownCareAdditionalObservation:
              data.ownCare.ownCareAdditionalObservation,
            writeAdditionalObservation: data.write.writeAdditionalObservation,
          },
        },
      };
    },
    async save(showMessage = true) {
      const data = {
        ...this.value,
        answers: [
          ...this.value.answers,
          ...(this.value.skillModel?.questions || []),
        ],
        communication: {
          comuniAdditionalObservation: this.value.skillModel?.additionalRemarks
            .comuniAdditionalObservation,
        },
        reading: {
          lectureAdditionalObservation: this.value.skillModel?.additionalRemarks
            .lectureAdditionalObservation,
          wordsPerMinutes: this.value.skillModel?.additionalRemarks
            .wordsPerMinutes,
        },
        math: {
          mathAdditionalObservation: this.value.skillModel?.additionalRemarks
            .mathAdditionalObservation,
        },
        moto: {
          motoAdditionalObservation: this.value.skillModel?.additionalRemarks
            .motoAdditionalObservation,
        },
        ownCare: {
          ownCareAdditionalObservation: this.value.skillModel?.additionalRemarks
            .ownCareAdditionalObservation,
        },
        write: {
          writeAdditionalObservation: this.value.skillModel?.additionalRemarks
            .writeAdditionalObservation,
        },
        cognitive: {
          cognitiveAdditionalObservation: this.value.skillModel
            ?.additionalRemarks.cognitiveAdditionalObservation,
        },
        sensory: {
          ophthalmologicEvaluation: this.value.skillModel?.additionalRemarks
            .ophthalmologicEvaluation,
          importObservations: this.value.skillModel?.additionalRemarks
            .importObservations,
          resultOfEvaluationAudiological: this.value.skillModel
            ?.additionalRemarks.resultOfEvaluationAudiological,
        },
      };

      referralService
        .saveEvaluationReportAnswer(this.referralId, data)
        .then(async () => {
          if (showMessage) {
            this.ShowToast(
              'Éxito',
              'Información ha sido guardada exitosamente.',
              'success'
            );
          }
        })
        .catch((error) => {
          this.ShowToast('Alerta', error?.response?.data.message, 'error');
        });
    },
    onSkillChanged() {},
    addSkill() {
      if (!this.skill) return;
      const data = {
        ...this.skill,
        disabled: this.isReadonly,
      };
      this.selectedSkills.push(data);
      this.skill = null;
    },
    async getSkills() {
      const { data } = await referralAndEquipmentsService.getSkills();
      this.skillOptions = data;
      return data;
    },
    onDeleteSkill({ skill, questionnaire }) {
      const questionIdToRemove = questionnaire
        ?.map((x) => x.questions)
        ?.flat()
        ?.map((x) => x.id);
      const itemIndex = this.selectedSkills.findIndex((x) => x.id == skill.id);
      this.selectedSkills.splice(itemIndex, 1);
      if (!questionIdToRemove) return;
      this.model.skillModel.questions = this.model.skillModel.questions.filter(
        (question) => {
          return !questionIdToRemove.includes(question.questionId);
        }
      );

      if (skill.id == referralsAndEquipmentSkills.CognitiveSkills) {
        this.value.skillModel.additionalRemarks.cognitiveAdditionalObservation = null;
      }
      if (skill.id == referralsAndEquipmentSkills.MotorSkills) {
        this.value.skillModel.additionalRemarks.motoAdditionalObservation = null;
      }
      if (skill.id == referralsAndEquipmentSkills.WritingSkills) {
        this.value.skillModel.additionalRemarks.writeAdditionalObservation = null;
      }
      if (skill.id == referralsAndEquipmentSkills.ReadingSkills) {
        this.value.skillModel.additionalRemarks.wordsPerMinutes = null;
        this.value.skillModel.additionalRemarks.lectureAdditionalObservation = null;
      }
      if (skill.id == referralsAndEquipmentSkills.SensorySkills) {
        this.value.skillModel.additionalRemarks.ophthalmologicEvaluation = null;
        this.value.skillModel.additionalRemarks.importObservations = null;
        this.value.skillModel.additionalRemarks.resultOfEvaluationAudiological = null;
      }
      if (skill.id == referralsAndEquipmentSkills.CommunicationSkills) {
        this.value.skillModel.additionalRemarks.comuniAdditionalObservation = null;
      }
      if (skill.id == referralsAndEquipmentSkills.MathematicsSkills) {
        this.value.skillModel.additionalRemarks.mathAdditionalObservation = null;
      }
      if (skill.id == referralsAndEquipmentSkills.SelfCareSkills) {
        this.value.skillModel.additionalRemarks.ownCareAdditionalObservation = null;
      }
    },
    async addCurrentSkill() {
      this.getSkills().then((data) => {
        for (let index = 0; index < this.model.skills.length; index++) {
          const skillId = this.model.skills[index];
          const item = data.find((x) => x.id == skillId);
          if (!item) continue;
          this.skill = item;
          this.addSkill();
        }
      });
    },
  },
};
</script>
<style lang="scss"></style>
